import { render, staticRenderFns } from "./ApplicationOfferTermsInfo.vue?vue&type=template&id=fa0ca484&scoped=true&lang=pug&"
import script from "./ApplicationOfferTermsInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationOfferTermsInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationOfferTermsInfo.vue?vue&type=style&index=0&id=fa0ca484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ca484",
  null
  
)

/* custom blocks */
import block0 from "./ApplicationOfferTermsInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports